module.exports = {
    enabled:{
        brevo: process.env.BREVO_ANALYTICS_ENABLED === 'true',
        matomo: process.env.MATOMO_ANALYTICS_ENABLED === 'true',
        gtm: process.env.GTM_ANALYTICS_ENABLED === 'true',
        google: process.env.ANALYTICS_ENABLED === 'true',
        tracking: process.env.ANALYTICS_TRACKING === 'true',
    },
    // Google Analytics
    google: {
        id: process.env.ANALYTICS_ID,
        params: {},
    },
    // Google Tag Manager
    gtm: {
        id: process.env.GTM_ANALYTICS_ID,
        auth: process.env.GTM_ANALYTICS_AUTH,
        preview: process.env.GTM_ANALYTICS_PREVIEW,
        cookiesWin: process.env.GTM_ANALYTICS_COOKIES_WIN,
    },
    // Matomo Analytics
    matomo: {
        host: process.env.MATOMO_ANALYTICS_HOST,
        siteId: process.env.MATOMO_ANALYTICS_SITE_ID,
        cookieDomain: process.env.MATOMO_ANALYTICS_COOKIE_DOMAIN,
    },
    brevo: {
        clientKey: process.env.BREVO_ANALYTICS_CLIENT_KEY,
    },
};
